<template>
  <div>
    <div v-if="noDeals">
      <p class="small"><em>Please review and complete any outstanding information for each transaction. <br><span class="text-danger">Note: If you haven't filled out any of the Custom ClarityNOW fields they will be defaulted when transferred and you will have to update those values as well.</span></em></p>
    </div>
    <div class="text-center" v-else>
      <strong>You currently do not have any incomplete deals.</strong>
    </div>
    <div v-if="pipelines.length > 0">
      <h3>Incomplete Pipelines</h3>
      <b-table responsive id="pipelines" small :items="pipelines" :fields="pipelineColumns">
        <template #cell(type)="row">
          <b-badge :variant="pipelineVariants[row.item.type]">{{ row.item.type }}</b-badge>
        </template>
        <template #cell(status)="row">
          <b-badge>{{ row.item.status }}</b-badge>
        </template>
        <template #cell(primary_source)="row">
          <span v-if="row.item.primary_source">{{ row.item.primary_source }}</span>
          <span v-if="row.item.primary_source && row.item.source"> - </span>
          <span v-if="row.item.source">{{ row.item.source }}</span>
        </template>
        <template #cell(name)="row">
          {{ row.item.client.name }}
        </template>
        <template #cell(full_address)="row">
          {{ row.item.property.full_address }}
        </template>
        <template #cell(phone)="row">
          {{ row.item.client.phone }}
        </template>
        <template #cell(email)="row">
          {{ row.item.client.email }}
        </template>
        <template #cell(price)="row">
          {{ row.item.price | currency }}
        </template>
        <template #cell(potential_gci)="row">
          {{ row.item.price * (row.item.commission / 100) | currency }}
        </template>
        <template #cell(potential_profit)="row">
          {{ (row.item.price * (row.item.commission / 100) * (row.item.cos / 100)) | currency }}
        </template>
        <template #cell(pipeline_rating)="row">
          <span v-if="ratingStatuses.includes(row.item.status)">
            {{ row.item.pipeline_rating }}
          </span>
        </template>

        <template #cell(actions)="row">
          <b-dropdown text="Actions" size="sm" variant="info" boundary="viewport">
            <b-dropdown-item variant="info" @click="handleEdit(row, 'pipelines')"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <!-- <b-dropdown-item variant="info" @click="$emit('showDeal', row.item.deal_id)" v-if="row.item.deal_id"><img src="/img/fub/fub-icon.png" class="mr-3" /> FUB Deal</b-dropdown-item> -->
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div v-if="listings.length > 0">
      <h3>Incomplete Listings</h3>
      <b-table responsive id="listings" small :items="listings" :fields="columns">
        <template #cell(actions)="row">
          <b-dropdown variant="info" size="sm" id="deal-actions" text="Actions">
            <b-dropdown-item variant="info" @click="handleEdit(row, 'listings')"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <!-- <b-dropdown-item variant="info" @click="$emit('showDeal', row.item.deal_id)" v-if="row.item.deal_id"><img src="/img/fub/fub-icon.png" class="mr-3" /> FUB Deal</b-dropdown-item> -->
          </b-dropdown>
        </template>
        <template #cell(status)="row">
          <b-badge :variant="variants[row.item.status]">{{ row.item.status }}</b-badge>
        </template>
        <template #cell(units)="row">
          <span v-if="row.item.units == true">Yes</span>
          <span v-else>No</span>
        </template>
        <template #cell(listing_price)="row">
          {{ row.item.listing_price | currency }}
        </template>
        <template #cell(sale_price)="row">
          {{ row.item.sale_price | currency }}
        </template>
        <template #cell(gross_commission)="row">
          {{ row.item.gross_commission | currency }}
        </template>
        <template #cell(net_commission)="row">
          {{ row.item.net_commission | currency }}
        </template>
      </b-table>
    </div>
    <div v-if="transactions.length > 0">
      <h3>Incomplete Transactions</h3>
      <b-table responsive id="transactions" small :items="transactions" :fields="columns">
        <template #cell(actions)="row">
          <b-dropdown variant="info" size="sm" id="deal-actions" text="Actions">
            <b-dropdown-item variant="info" @click="handleEdit(row, 'transactions')"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <!-- <b-dropdown-item variant="info" @click="$emit('showDeal', row.item.deal_id)" v-if="row.item.deal_id"><img src="/img/fub/fub-icon.png" class="mr-3" /> FUB Deal</b-dropdown-item> -->
          </b-dropdown>
        </template>
        <template #cell(status)="row">
          <b-badge :variant="variants[row.item.status]">{{ row.item.status }}</b-badge>
        </template>
        <template #cell(units)="row">
          <span v-if="row.item.units == true">Yes</span>
          <span v-else>No</span>
        </template>
        <template #cell(listing_price)="row">
          {{ row.item.listing_price | currency }}
        </template>
        <template #cell(sale_price)="row">
          {{ row.item.sale_price | currency }}
        </template>
        <template #cell(gross_commission)="row">
          {{ row.item.gross_commission | currency }}
        </template>
        <template #cell(net_commission)="row">
          {{ row.item.net_commission | currency }}
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import columns from './incompleteColumns';
import pipelineColumns from './pipelineColumns';

export default {
  props: {
    userRoute: null
  },
  data() {
    return {
      columns: columns,
      pipelineColumns: pipelineColumns,
      pipelines: [],
      listings: [],
      transactions: [],
      variants: {
        'coming-soon': 'info',
        active: 'success',
        pending: 'info',
        closed: 'success'
      },
      ratingStatuses: [
        'Nurture',
        'Appt Set',
        'Appt Held',
        'Agreement Signed',
        'Listing Taken'
      ],
      pipelineVariants: {
        listing: 'success',
        buyer: 'info'
      }
    }
  },
  computed: {
    noDeals() {
      return this.pipelines.length > 0 || this.listings.length > 0 || this.transactions.length > 0;
    }
  },
  methods: {
    async getIncompletePipelines() {
      await axios.get(this.userRoute + "/integrations/fub/incomplete?type=pipelines")
      .then(response => {
        this.pipelines = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getIncompleteListings() {
      await axios.get(this.userRoute + "/integrations/fub/incomplete?type=listings")
      .then(response => {
        this.listings = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getIncompleteTransactions() {
      await axios.get(this.userRoute + "/integrations/fub/incomplete?type=transactions")
      .then(response => {
        this.transactions = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleEdit(row, section) {
      const path = '/' + section + '/' + row.item.id;
      this.$router.push({
        path: path,
      });
    },
  },
  created() {
    this.getIncompletePipelines();
    this.getIncompleteListings();
    this.getIncompleteTransactions();
  }
};
</script>